import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './quasar'


//#VUERESOURCE#################################################
import VueResource from 'vue-resource'
Vue.use(VueResource)


//#FIREBASE AUTH###############################################
import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

//#  UUID       ###############################################
import UUID from "vue-uuid";

Vue.use(UUID);



// Your web app's Firebase configuration
var firebaseConfig = {
  "projectId": "modern-index-220210",
  "appId": "1:926071916170:web:8bcc325290151800900f73",
  "databaseURL": "https://modern-index-220210.firebaseio.com",
  "storageBucket": "modern-index-220210.appspot.com",
  "locationId": "europe-west",
  "apiKey": "AIzaSyCmpLHwx6UrZq3iV05bqiQANSIBD35oTik",
  "authDomain": "modern-index-220210.firebaseapp.com",
  "messagingSenderId": "926071916170",
  "measurementId": "G-4ER50CW6LW"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.config.productionTip = false

// alias
Vue.prototype.$analytics = firebase.analytics();

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
